import uuid from 'uuid/v4';
import itemsSlider from '../components/Views/DragAndDrop/ItemsModules/itemsSlider';

export const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

export const copy = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const item = sourceClone[droppableSource.index];
  destClone.splice(droppableDestination.index, 0, { ...item, id: uuid() });
  return destClone;
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const transformCarouselToDnD = (carousel) => {
  const carouselObject = {};

  carouselObject.id = uuid();
  carouselObject.content = 'Carousel';
  carouselObject.readableName = 'Carousel';
  carouselObject.type = 'item';
  carouselObject.component = {};

  carouselObject.component.type = 'Carousel';
  carouselObject.component.isFooterSlider = carousel.isFooterSlider || false;
  carouselObject.component.maxChildComponents = carousel.maxChildComponents || 0;
  carouselObject.component.components = [];
  carousel.components.forEach((slideComponent) => {
    const slide = {
      content: slideComponent.type,
      id: uuid(),
      readableName: 'Slider',
      type: 'item',
      component: {
        type: slideComponent.type,
        image: slideComponent.image,
        left: [],
        right: [],
        scheduledDate: slideComponent.scheduledDate,
        expirationDate: slideComponent.expirationDate,
        url: slideComponent.url,
        showOpacity: slideComponent.showOpacity,
        dropDownItems: slideComponent.dropDownItems,
      },
    };
    // push items to the left
    slideComponent.left.forEach((comp) => {
      const readableNameMappedFromItems = itemsSlider.filter(i => i.content === comp.type)[0];
      const readableName = readableNameMappedFromItems ? readableNameMappedFromItems.readableName : comp.type;
      const componentObject = {
        content: comp.type,
        id: uuid(),
        component: comp,
        readableName,
      };
      slide.component.left.push(componentObject);
    });

    // push items to the right
    slideComponent.right.forEach((comp) => {
      const readableNameMappedFromItems = itemsSlider.filter(i => i.content === comp.type)[0];
      const readableName = readableNameMappedFromItems ? readableNameMappedFromItems.readableName : comp.type;
      const componentObject = {
        content: comp.type,
        id: uuid(),
        component: comp,
        readableName,
      };
      slide.component.right.push(componentObject);
    });

    carouselObject.component.components.push(slide);
  });

  return carouselObject;
};

export const transformCarouselFromDnD = (obj) => {
  let carouselComponent = {};
  const carouselComponents = obj.component.components || [];
  carouselComponent = obj.component;
  carouselComponent.components = [];

  carouselComponents.forEach((slideComponent) => {
    const slide = slideComponent.component || {};
    const newSlide = { ...slide };

    if (slide.left) {
      const left = [];
      slide.left.forEach((component) => {
        left.push(component.component);
      });
      newSlide.left = left;
    }

    if (slide.right) {
      const right = [];
      slide.right.forEach((component) => {
        right.push(component.component);
      });
      newSlide.right = right;
    }
    carouselComponent.components.push(newSlide);
  });

  return carouselComponent;
};

export const transformFilterFromDnD = (obj) => {
  let filterComponent = {};
  const filterComponents = obj.component.components || [];
  filterComponent = obj.component;
  filterComponent.components = [];
  filterComponents.forEach((filterComp) => {
    const filterHolder = filterComp.component;
    const components = [];

    filterHolder.components.forEach((component) => {
      const modifiedCompWithCompId = { ...component };
      if (component.component && !component.component.compId) {
        modifiedCompWithCompId.component.compId = `${component.component.type}_${uuid()}`;
      }
      components.push(modifiedCompWithCompId.component);
    });

    filterHolder.components = components;
    filterComponent.components.push(filterHolder);
  });

  return filterComponent;
};

export const transformFilterToDnD = (filterComponent) => {
  const carouselObject = {};
  carouselObject.id = uuid();
  carouselObject.content = 'FilterContainer';
  carouselObject.readableName = 'Filter';
  carouselObject.type = 'item';
  carouselObject.component = {};

  carouselObject.component.type = 'FilterContainer';
  carouselObject.component.filterHeading = filterComponent.filterHeading || {
    en: '', es: '', ca: '', pt: '',
  };
  carouselObject.component.filterText = filterComponent.filterText || {
    en: '', es: '', ca: '', pt: '',
  };
  carouselObject.component.components = [];
  filterComponent.components.forEach((filterComp) => {
    const slide = {
      content: filterComp.type,
      id: uuid(),
      readableName: 'Filter holder',
      type: 'item',
      component: {
        type: 'FilterHolder',
        name: filterComp.name,
        components: [],
      },
    };
    // push items to the left
    filterComp.components.forEach((comp) => {
      const readableNameMappedFromItems = itemsSlider.filter(i => i.content === comp.type)[0];
      const readableName = readableNameMappedFromItems ? readableNameMappedFromItems.readableName : comp.type;
      let componentObject = {};
      if (comp.hasOwnProperty('key')) {
        componentObject = {
          content: comp.key,
          id: uuid(),
          type: 'reusableItem',
          readableName: `Reusable item ${comp.key}`,
        };
      } else {
        componentObject = {
          content: comp.type,
          id: uuid(),
          component: comp,
          readableName,
        };
      }
      slide.component.components.push(componentObject);
    });
    carouselObject.component.components.push(slide);
  });
  return carouselObject;
};


export const transformTagsRowFromDnD = (obj) => {
  let tagsRowComponent = {};
  const tagsRowComponents = obj.component.components;
  tagsRowComponent = obj.component;
  tagsRowComponent.components = [];
  tagsRowComponents.forEach((tagsRowComp) => {
    const tagsRow = tagsRowComp.component;
    const components = [];

    tagsRow.components.forEach((component) => {
      const modifiedCompWithCompId = { ...component };
      if (component.component && !component.component.compId) {
        modifiedCompWithCompId.component.compId = `${component.component.type}_${uuid()}`;
      }
      components.push(modifiedCompWithCompId.component);
    });

    tagsRow.components = components;
    tagsRowComponent.components.push(tagsRow);
  });

  return tagsRowComponent;
};

export const transformTagsRowtoDnD = (tagsRowComponent) => {
  const tagsRowObj = {};
  tagsRowObj.id = uuid();
  tagsRowObj.content = 'TagsRow';
  tagsRowObj.readableName = 'Tags Row';
  tagsRowObj.type = 'item';
  tagsRowObj.component = {};

  tagsRowObj.component.type = 'TagsRow';
  tagsRowObj.component.className = tagsRowComponent.filterHeading || '';
  tagsRowObj.component.components = [];
  tagsRowComponent.components.forEach((tagsRowComp) => {
    const tagWithLink = {
      content: tagsRowComp.type,
      id: uuid(),
      readableName: 'Tag',
      type: 'item',
      component: {
        type: 'TagWithLink',
        text: tagsRowComp.text,
        url: tagsRowComp.url,
      },
    };
    tagsRowObj.component.components.push(tagWithLink);
  });
  return tagsRowObj;
};
